import type React from 'react';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { document } from '../../../../../../../js/globals';
import Section from '../../../../../../general/Section/Section';

const GiftyInline: React.FC = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const observer = new MutationObserver((mutations, obs) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    setIsLoaded(true);
                    obs.disconnect();
                }
            });
        });

        const targetNode = document?.querySelector('.cm-inline-js');
        if (targetNode) {
            observer.observe(targetNode, { childList: true });
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <Section>
            {!isLoaded && <Skeleton height={580} width="100%" containerTestId="giftyInlineLoader" />}
            <div className="cm-inline-js" title="cm-inline-js" />
        </Section>
    );
};

export default GiftyInline;
